module.exports = __webpack_public_path__ + "static/media/caret.d3b5a2d7.svg";